import React, {  useContext, useEffect, useState } from "react";
import './styles.scss';
import { Checkbox, CheckboxProps, Button, Form, Input, InputNumber, Modal,  Select, Descriptions } from "antd";
import { CurrentAccountComissionProps } from "./types";
import { useGetAllClients } from "../../../Services/useGetAllClients";
import { useOperations } from "../../../Services/useOperations";
import { VariablesContext } from "../../../Contexts/UserContext/VariablesContext";
import { UserContext } from "../../../Contexts/UserContext/UsersContext";
import { Transaction } from "../../../Services/useGetMovements";
import ModalTitle from "../../ModalTitle";
import { OperationsContext } from "../../../Contexts/UserContext/OperationsContext";
import { useGetCurrency } from "../../../Services/useGetCurrency";
import NewCustomer from "../../NewCustomer";

export interface FilterValues{
    value: string;
    label: string;
    key: number;
}

interface inputsForms{
    date: {$d:string}
    client: number;
    amount: number;
    currency: number;
    description: string; 
}

export type OperationDataCommission = {
    description: string;
    type_id: number;
    customer_id: number;
    approved: boolean;
    currency_id: number;
    commission?: number;     
    debit?: number;
    credit?: number;
    destination_checkout_id?: number;
    origin_checkout_id?: number;
    transfer_costs?: number;
    client_pays_costs?: boolean;
};

export type valuesCommission ={
    
    type_id: number, //Comisión en cuenta cliente  
    approved: boolean  
    currency_id: number,
    customer_id: number,
    approved_db?: boolean, 
    debit?: number,
    deleted?: boolean,
    description?: string,   
    id?: number,
    key?: number,
    operation_id?: number,  
    related_load_operation_id?: number      
}

export const CurrentAccountComission: React.FC<CurrentAccountComissionProps> =({
    form, 
    showAddCommission, 
    setShowAddComission,
    values,
    movementsTransactions,
    listComission,
    setListCommission,
    customers
})=>{
    
    const { data: clients } = useGetAllClients()
    const { setRowSelect } = useContext(OperationsContext)
    const { userData } = useContext(UserContext)
    const { data: currencies} = useGetCurrency()
    const { collapsedFilsters, setCollapsedFilters, dataTransactionsToForm, setDataTransactionsToForm} = useContext(VariablesContext)
    const { setShowForms, showForms } = useContext(VariablesContext)
    const { createOperation, editOperation, getOperation } = useOperations() 
    const { Option } = Select;
    const [ aproved, setAproved ] = useState(false)
    const [ currency, setCurrency ] = useState<number>()
    const [disabledForm, setDisableForm] = useState<{
        disable: boolean,
        approved: boolean,
        deleted: boolean,
        operationNumber: number | undefined
    }>({
        disable: true,
        approved: false,
        deleted: false,
        operationNumber: undefined
    })

    const mandatory = [
        {
            required: true,
            message:'Este campo es obligatorio'
        }
    ]  

    const handleCancel =()=>{
        if(showAddCommission && setShowAddComission){
            setShowAddComission(false)
        }else{
            setShowForms(Object.fromEntries(Object.keys(showForms).map(key => [key, false])))// pone todos en false
            if(dataTransactionsToForm){
                setDataTransactionsToForm(undefined)  
            }       
            setRowSelect(undefined) 
        }
       
    }
    const handleRemove = () =>{
        if(values && setListCommission && listComission){
            let newList = listComission?.filter((x)=> x.key !== values.key)            
            setListCommission(newList)  
            handleCancel()            
        }        
    }

   

    useEffect(() => {
        if(values){
            uploadFormWhitValues()
        }else if(dataTransactionsToForm){
            uploadForm(dataTransactionsToForm)
        }else{
            setDisableForm({
                disable: false,
                approved: false,
                deleted: false,
                operationNumber: undefined
            })
            form.resetFields(undefined) 
            form.setFieldsValue({ commission: 3 });
        }       
    }, []);

    const uploadFormWhitValues =()=>{
        if(values){
            setDisableForm({
                disable: values.approved_db || values.deleted ? true : false,
                approved: values.approved_db || false,
                deleted: values.deleted || false,
                operationNumber: values.operation_id
            })
            setAproved(values.approved)                
            setCurrency(values.currency_id)        

            form.setFieldsValue({
                client: values.customer_id,       
                currency: values.currency_id,
                amount: values.debit,
                description: values.description
            });
        }
         
    }

    const uploadForm = async(response: Transaction) =>{           
        setDisableForm({
            disable: response.approved || response.deleted ? true : false,
            approved: response.approved || false,
            deleted: response.deleted || false,
            operationNumber: response.operation_id
        })
        setAproved(response.approved)                
        setCurrency(response.origin_account?.currency?.id )        

        form.setFieldsValue({
            client: response.customer.id,       
            currency: response.origin_account?.currency?.id,
            amount: response.debit,
        });                                             
    }

    const confirmSave = async(operationData: OperationDataCommission)=>{       
        if(dataTransactionsToForm){
            await editOperation(handleCancel, dataTransactionsToForm.id.toString(), operationData)
        }else{
            await createOperation(handleCancel, operationData)
        }  
        setCollapsedFilters(!collapsedFilsters)                    
    }

    const addCommissionInList = () =>{

    }

    const handleSave = async (e: inputsForms)=>{
        if(userData){
            let operationData: OperationDataCommission = {
                description: e.description,
                type_id: 16, //Comisión en cuenta cliente
                customer_id: e.client,
                currency_id: e.currency, 
                debit: Number(e.amount),  
                approved: aproved
            }
            if(listComission && !movementsTransactions?.approved && setListCommission){                    
                if (values && values.id && listComission) {
                    const updatedMovements = listComission.map(item =>
                        item.id === values.id ? { ...item, ...operationData } : item
                    );
                    setListCommission(updatedMovements);
                }else if(values?.key !== undefined && listComission){
                    const updatedMovements = listComission.map((item, index) =>
                        index === values.key ? { ...item, ...operationData } : item
                    );
                    setListCommission(updatedMovements);
                }else{     
                    let opertations: valuesCommission = operationData                                   
                    let data = listComission || [];
                    data.push(operationData);
                    setListCommission(data);
                }
                handleCancel()
            }else{
                Modal.confirm({
                    title: 'Confirmar operación',
                    okText: 'Confirmar',
                    cancelText: 'Cancelar',
                    onOk:()=> {
                        if(operationData ){
                            if(showAddCommission){
                                addCommissionInList()
                            }else{
                                confirmSave(operationData)
                            }
                    }},
                    content: (
                        <div>
                            <p><strong>Comisión en cuenta corriente</strong></p>
                            {operationData.customer_id && <p><strong>Cliente: </strong> {clients.find((x)=>x.id === e.client)?.first_name + ' ' + clients.find((x)=>x.id === e.client)?.last_name}</p>}                                         
                            <p><strong>Comisión a debitar: </strong>{currency && currencies  && currencies.find((x)=>x.id === currency)?.sign} {Number(e.amount).toLocaleString("es-AR",{maximumFractionDigits:2, minimumFractionDigits:2})}</p>
                            <p>
                                <strong>Estado: </strong>
                                <strong style={{ color: operationData.approved ? 'green' : 'orange' }}>
                                    {operationData.approved ? 'Aprobado' : 'Sin aprobar'}
                                </strong>
                            </p>                                                                                                                  
                        </div>
                    ),
                });
            } 

        }               
    }    

    const onChangeCurrency = async(e: number) =>{
        setCurrency(e)        
    }
 
    const onChangeAproved: CheckboxProps['onChange'] = async (e) => {
        setAproved(e.target.checked); 
    };

    const changePoint = (e:  React.KeyboardEvent<HTMLInputElement>)=>{
        const input = e.currentTarget as HTMLInputElement;
        const start = input.selectionStart ?? 0;
        const end = input.selectionEnd ?? 0;
        let newValue = input.value

        if (e.key === '.' && !e.shiftKey) {
            e.preventDefault();
            if (!input.value.includes(',')) {
                newValue = input.value.substring(0, start) + ',' + input.value.substring(end);
                input.value = newValue;
                input.setSelectionRange(start + 1, start + 1);
                input.dispatchEvent(new Event('input', { bubbles: true }));
            }
        }else if (e.key === ',') {
            e.preventDefault();
            if (!input.value.includes(',')) {
                newValue = input.value.substring(0, start) + ',' + input.value.substring(end);
                input.value = newValue;
                input.setSelectionRange(start + 1, start + 1);
                input.dispatchEvent(new Event('input', { bubbles: true }));
            }
        }
    }

    return(
        <div>
            <Modal
                style={{ top: 10 }}
                title= {
                    <ModalTitle 
                        title={'Comisión en cuenta corriente cliente'} 
                        isApproved={disabledForm.approved}
                        isDeleted={disabledForm.deleted}
                        operationNumber={disabledForm.operationNumber ? disabledForm.operationNumber : undefined}
                    />
                }
                open={showForms.current_account_commission || showAddCommission}
                onCancel={handleCancel}                   
                okText="Guardar"
                cancelText="Cancelar" 
                onOk={()=>form.submit()}
                footer={
                    disabledForm.disable ? null : [
                        values && !values?.id && <Button key="extra" onClick={handleRemove}>Quitar de lista</Button>,
                        <Button key="cancel" onClick={handleCancel}>Cancelar</Button>,
                        <Button key="submit" type="primary" onClick={() => form.submit()}>Guardar</Button>
                    ]
                }
            >
                {!disabledForm.disable && <NewCustomer justify={"end"} positions= {'leftTop'} />}
                <Form
                    form={form}
                    id='form_deposit_extraction'
                    onFinish={handleSave}
                    layout="vertical"
                    
                >                                                        
                    <Form.Item
                        label='Cliente'
                        name='client'
                        rules={[
                            {
                                required: true,
                                message:'Este campo es obligatorio'
                            }
                        ]}
                    >
                        <Select
                            disabled={disabledForm.disable}
                            loading={!clients}
                            placeholder={!clients ? 'Cargando campos...' : 'Cliente'}
                            style={{ minWidth: '200px' }}
                            showSearch
                            filterOption={(input, option) =>
                                (option?.children?.toString().toLowerCase() || '').includes(input.toLowerCase())
                            } 
                        >
                            {clients &&
                                clients
                                .filter((item) =>
                                    customers
                                    ? item.id === customers.destination || item.id === customers.origin
                                    : true
                                )
                                .map((item) => (
                                    <Option value={item.id} key={item.id}>
                                    {item.first_name + ' ' + item.last_name}
                                    </Option>
                                ))}
                        </Select>
                    </Form.Item> 
                    <Form.Item
                        label='Moneda'
                        name='currency'
                        rules={[
                            {
                                required: true,
                                message:'Este campo es obligatorio'
                            }
                        ]}
                    >
                        <Select
                            disabled={disabledForm.disable || showAddCommission} 
                            loading={!currencies }
                            placeholder={!currencies ? 'Cargando campos...' : 'Moneda'}      
                            style={{minWidth: '200px'}} 
                            showSearch   
                            onChange={onChangeCurrency}                                 
                        >
                            {currencies && currencies.map((item) => (
                                <Option value={item.id}>
                                    {item.name}
                                </Option>
                            ))} 
                        </Select>
                    </Form.Item>        
                    <Form.Item
                        label='Comisión a debitar'
                        name='amount'
                        rules={[
                            {
                                required: true,
                                message:'Este campo es obligatorio'
                            }
                        ]}
                    >
                        <InputNumber
                            disabled={disabledForm.disable}
                            addonBefore={currency ? currencies.find((x)=>x.id == currency)?.sign : ' ¤ '} 
                            placeholder="Monto"
                            formatter={value =>
                                value
                                    ? new Intl.NumberFormat('es-AR', {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 20
                                    }).format(Number(value))
                                    : ''
                            }
                            onKeyDown={changePoint}
                            parser={value => value?.replace(/\./g, '').replace(',', '.') || ''}
                            stringMode 
                        />
                    </Form.Item>                                                                                                          
                                                     
                    <Checkbox
                        
                        style={{width: '100%', marginBottom: 15}}
                        disabled={disabledForm.approved}
                        checked={aproved}
                        onChange={onChangeAproved}
                    >
                        Aprobado
                    </Checkbox>
                    <Form.Item
                        label='Descripción'
                        name='description'
                    >
                        <Input
                            disabled={disabledForm.disable}
                            placeholder="Comentario"
                        />
                    </Form.Item>                                                                    
                </Form>
            </Modal>
        </div>
    )
}

export default CurrentAccountComission;
